import { defineStore } from 'pinia'

import { StoreId } from '@/store'
import { DEFAULT_STATE_ADDRESS_SYSTEM } from '@/store/addressSystem/address-system.constants'
import type {
  AddressSystemState,
  SelectedAddress,
} from '@/store/addressSystem/address-system.types'
import { getDefaultDeliveryAddress } from '@/store/addressSystem/address-system.utils'
import type {
  DeliveryDataAddress,
  PlacesSearch,
} from '@/store/delivery/delivery.types'
import { useUserStore } from '@/store/user/user'

import { SetDeliveryMethodPayload } from '@/api/modules/basket/types'
import { StateGeoAddress } from '@/types/mapServices'

import { storage } from '@/services/storage'
import { STORAGE_KEY } from '@/services/storage/constants'

export const useAddressSystemStore = defineStore(StoreId.ADDRESS_SYSTEM, {
  state: (): AddressSystemState => DEFAULT_STATE_ADDRESS_SYSTEM,
  actions: {
    setVisibleAddressSystemDialog(state: boolean) {
      this.$state.isVisibleAddressSystemDialog = state
    },
    setSelectedAddress(selectedAddress: SelectedAddress) {
      this.$state.selectedAddress = selectedAddress
    },
    setLoadingWidget(loading: boolean) {
      this.$state.isLoadingWidget = loading
    },
    changeDeliveryWidget(payload: SetDeliveryMethodPayload) {
      const { isAuthenticated } = useUserStore()

      this.$state.delivery.widget = { ...payload }

      if (isAuthenticated) return

      storage.set(STORAGE_KEY.addressSystem.deliveryWidget, payload)
    },
    changeDeliveryBasket(payload: SetDeliveryMethodPayload) {
      this.$state.delivery.basket = payload
    },
    setDeliveryAddress(deliveryDataAddress: DeliveryDataAddress) {
      this.deliveryAddress = deliveryDataAddress
    },
    setDeliveryAddressState(state: StateGeoAddress) {
      this.deliveryAddress.state = state
    },
    resetDeliveryAddress(place: PlacesSearch | null = null) {
      this.deliveryAddress = getDefaultDeliveryAddress(place)
    },
  },
  getters: {
    deliveryBasket: ({ delivery }) => delivery.basket,
    deliveryWidget: ({ delivery }) => delivery.widget,
  },
})
